import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { buildReportParams } from "./dashboardFilters";

// Consolidado SA (opcional — se falhar, mantém o valor atual e os outros cards continuam).
async function fetchConsolidado(start, end) {
  const p = new URLSearchParams();
  if (start) p.set("start", start);
  if (end) p.set("end", end);
  try {
    return (await api.get(`/dashboard/consolidated?${p.toString()}`)).data;
  } catch (e) {
    console.debug("consolidado indisponível", e);
    return undefined;
  }
}

// Dados do Dashboard: stats (polling 30s + evento entregas-changed), catálogos de filtro,
// panorama 7 dias e consolidado SA (só na aba "consolidado").
export function useDashboardData({ filters, currentEmpresaId, isAdmin, tab, empresas }) {
  const [s, setS] = useState(null);
  const [cons, setCons] = useState(null);
  const [entregadores, setEnt] = useState([]);
  const [regioes, setReg] = useState([]);
  const [bairros, setBai] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [totals7d, setTotals7d] = useState(null);

  useEffect(() => {
    api.get("/entregadores").then((r) => setEnt(r.data));
    api.get("/regioes").then((r) => setReg(r.data));
    api.get("/bairros").then((r) => setBai(r.data));
    api.get("/tipos-entrega").then((r) => setTipos(r.data)).catch(() => setTipos([]));
  }, []);

  useEffect(() => {
    const today = new Date();
    const start = new Date(today); start.setDate(start.getDate() - 6);
    const iso = (d) => d.toISOString().slice(0, 10);
    api.get(`/reports/totals?start=${iso(start)}&end=${iso(today)}&compare_previous=true`)
      .then((r) => setTotals7d(r.data))
      .catch(() => setTotals7d(null));
  }, [currentEmpresaId]);

  const qs = useMemo(() => {
    const p = buildReportParams(filters);
    p.set("compare_previous", "true");
    return p.toString();
  }, [filters]);

  useEffect(() => {
    const load = () => api.get(`/dashboard/stats?${qs}`).then((r) => setS(r.data));
    load();
    const t = setInterval(load, 30000);
    // Refresh imediato quando entregador altera status na mesma sessão
    window.addEventListener("entregas-changed", load);
    return () => { clearInterval(t); window.removeEventListener("entregas-changed", load); };
  }, [qs, currentEmpresaId]);

  const applyCons = (d) => { if (d !== undefined) setCons(d); };
  const reloadCons = () => { if (isAdmin && tab === "consolidado") fetchConsolidado(filters.start, filters.end).then(applyCons); };
  useEffect(() => {
    if (isAdmin && tab === "consolidado") fetchConsolidado(filters.start, filters.end).then((d) => { if (d !== undefined) setCons(d); });
  }, [tab, filters.start, filters.end, isAdmin, empresas]);

  const bairrosFiltrados = useMemo(
    () => (filters.regiao_id === "all" ? bairros : bairros.filter((b) => b.regiao_id === filters.regiao_id)),
    [bairros, filters.regiao_id],
  );

  return { s, cons, entregadores, regioes, tipos, bairrosFiltrados, totals7d, reloadCons };
}
